(() => {
  const summarySelector = [
    '.facets-vertical details.facets__disclosure-vertical > summary',
    '.firn-category-filter details > summary',
    '.product__accordion details > summary',
    '.firn-description-item > summary'
  ].join(', ');
  const duration = 280;
  const easing = 'cubic-bezier(0.22, 1, 0.36, 1)';
  const runningAnimations = new WeakMap();

  const getContent = (details, summary) =>
    Array.from(details.children).find((child) => child !== summary);

  const clearAnimationStyles = (content) => {
    content.style.removeProperty('height');
    content.style.removeProperty('overflow');
    content.style.removeProperty('opacity');
    content.style.removeProperty('transform');
  };

  const finishRunningAnimation = (details) => {
    const animation = runningAnimations.get(details);
    if (animation) animation.finish();
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    if (!summary || !summary.matches(summarySelector)) return;

    const details = summary.parentElement;
    const content = getContent(details, summary);
    if (!content) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    event.preventDefault();
    finishRunningAnimation(details);

    const isClosing = details.open;
    const startHeight = isClosing ? content.getBoundingClientRect().height : 0;

    if (!isClosing) {
      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
    } else {
      summary.setAttribute('aria-expanded', 'false');
    }

    const endHeight = isClosing ? 0 : content.scrollHeight;
    content.style.overflow = 'hidden';

    const animation = content.animate(
      [
        {
          height: `${startHeight}px`,
          opacity: isClosing ? 1 : 0,
          transform: isClosing ? 'translateY(0)' : 'translateY(-6px)'
        },
        {
          height: `${endHeight}px`,
          opacity: isClosing ? 0 : 1,
          transform: isClosing ? 'translateY(-4px)' : 'translateY(0)'
        }
      ],
      { duration, easing }
    );

    runningAnimations.set(details, animation);
    details.classList.toggle('firn-details-closing', isClosing);
    details.classList.toggle('firn-details-opening', !isClosing);

    animation.addEventListener('finish', () => {
      if (isClosing) details.open = false;
      details.classList.remove('firn-details-closing', 'firn-details-opening');
      clearAnimationStyles(content);
      runningAnimations.delete(details);
    }, { once: true });

    animation.addEventListener('cancel', () => {
      details.classList.remove('firn-details-closing', 'firn-details-opening');
      clearAnimationStyles(content);
      runningAnimations.delete(details);
    }, { once: true });
  });
})();